"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectVisibility = void 0;
var ProjectVisibility;
exports.ProjectVisibility = ProjectVisibility;
(function (ProjectVisibility) {
  ProjectVisibility["Private"] = "private";
  ProjectVisibility["Organization"] = "organization";
  ProjectVisibility["Public"] = "public";
})(ProjectVisibility || (exports.ProjectVisibility = ProjectVisibility = {}));